import { useEffect } from "react";
import axios from "axios";

// Loads Google Tag Manager / Microsoft Clarity once, only when an admin has set their IDs in SEO & Google Rankings.
export function SiteTags() {
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/seo-tags`).then(({ data }) => {
      if (data.gtm_id && !document.getElementById("lif-gtm")) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ "gtm.start": Date.now(), event: "gtm.js" });
        const s = Object.assign(document.createElement("script"), { id: "lif-gtm", async: true, src: `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(data.gtm_id)}` });
        document.head.appendChild(s);
      }
      if (data.clarity_id && !document.getElementById("lif-clarity")) {
        window.clarity = window.clarity || function (...a) { (window.clarity.q = window.clarity.q || []).push(a); };
        const s = Object.assign(document.createElement("script"), { id: "lif-clarity", async: true, src: `https://www.clarity.ms/tag/${encodeURIComponent(data.clarity_id)}` });
        document.head.appendChild(s);
      }
    }).catch(() => {});
  }, []);
  return null;
}
